module.exports = "pegasus_template/assets/rad-back.png";